import { GetRestricoesCalendarioConfig, RestricoesCalendarioConfig } from './calendario.types';

const restricoesCalendario: RestricoesCalendarioConfig = {
  marcas: ['ibmec'],
  modalidalidade: [],
  tipoCurso: [],
  codigoCurso: ['7124'],
};

export const getRestricoesCalendario: GetRestricoesCalendarioConfig = () => {
  return restricoesCalendario;
};
